import { useQuery } from "@tanstack/react-query"
import { API } from "config"
import moment from "moment"

const useBonusList = (page = 1, term) => useQuery({ queryKey: [`bonus-list`, page, term], queryFn: async () => {
    const callback = await API.get(`/bonus?page=${page}${term ? `&term=${term}` : ''}`)
    return callback?.data
}, staleTime: 1000 * 60 * 1, gcTime: 1000 * 60 * 60 * 60 })

export default useBonusList